import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { Button, InlineStack, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { setDestroy, setIsModalxOpen } from "components/modalx/modalx.slice";
import { useParams } from "react-router-dom";
import { setCategoryAsFavorite } from "services/files-category.service";
import { fetchCategoryDetails } from "containers/document/category-tree/category-tree.Slice";

interface CategoryFavoriteConfirmProps {
  categoryId: string;
  categoryName: string;
  isFavorite: boolean;
  source?: string;
}

const CategoryFavoriteConfirm: React.FC<CategoryFavoriteConfirmProps> = ({
  categoryId,
  categoryName,
  isFavorite,
  source = "",
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const { companyId } = useParams<{ companyId: string }>();

  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errMsg, setErrMsg] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleToggleFavorite = async () => {
    try {
      setIsLoading(true);
      if (companyId && categoryId) {
        await setCategoryAsFavorite(companyId, categoryId);
        // Reload the tree data to reflect the change
        dispatch(fetchCategoryDetails({ companyId, source }));
        setSuccessMessage("ok");
        setIsLoading(false);
        closeModal();
      }
    } catch (e) {
      setErrMsg("error");
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    dispatch(setIsModalxOpen(false));
    dispatch(setDestroy());
  };

  return (
    <>
      <div className="form-warnings">
        {errMsg && (
          <div>
            <Banner tone="critical">{t(errMsg)}</Banner>
          </div>
        )}
        {successMessage && (
          <div>
            <Banner tone="info">{t(successMessage)}</Banner>
          </div>
        )}
      </div>
      <h1 style={{ textAlign: "center" }}>
        {isFavorite
          ? `${t("are_you_sure_you_want_to_remove")} "${categoryName}" ${t(
              "from_favorites"
            )}?`
          : `${t("are_you_sure_you_want_to_add")} "${categoryName}" ${t(
              "to_favorites"
            )}?`}
      </h1>

      <InlineStack align="space-between">
        <Button onClick={handleToggleFavorite} loading={isLoading}>
          {t("Yes")}
        </Button>

        <Button onClick={closeModal}>{t("No")}</Button>
      </InlineStack>
    </>
  );
};

export default CategoryFavoriteConfirm;
